import React, { useEffect, useState } from "react";

export function useCountdown(endsAt) {
  const [parts, setParts] = useState({ h: "00", m: "00", s: "00" });
  useEffect(() => {
    const tick = () => {
      const end = endsAt ? new Date(endsAt).getTime() : Date.now();
      let rem = Math.max(0, end - Date.now());
      const h = Math.floor(rem / 3600000);
      const m = Math.floor((rem % 3600000) / 60000);
      const s = Math.floor((rem % 60000) / 1000);
      setParts({
        h: String(h).padStart(2, "0"),
        m: String(m).padStart(2, "0"),
        s: String(s).padStart(2, "0"),
      });
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [endsAt]);
  return parts;
}

export default function Countdown({ endsAt, size = "lg" }) {
  const { h, m, s } = useCountdown(endsAt);
  const box = size === "lg" ? "text-4xl px-4 py-3" : "text-2xl px-3 py-2";
  const Unit = ({ v, l }) => (
    <div className="flex flex-col items-center">
      <div className={`surface-2 rounded-xl font-mono font-bold tabular-nums text-white ${box}`}>{v}</div>
      <span className="mt-2 font-mono text-[9px] uppercase tracking-widest text-neutral-500">{l}</span>
    </div>
  );
  return (
    <div className="flex items-start gap-2" data-testid="countdown">
      <Unit v={h} l="Hours" />
      <span className="pt-2 font-mono text-2xl text-neutral-600">:</span>
      <Unit v={m} l="Min" />
      <span className="pt-2 font-mono text-2xl text-neutral-600">:</span>
      <Unit v={s} l="Sec" />
    </div>
  );
}
